export default __webpack_public_path__ + "static/media/dfea9583a4476c5d3671529e0684575f.png";